import React from "react";
import "../images/monashLogo.png";

const Header = ({}) => {
  const buttonsToGenerate = [{ text: "Home" }, { text: "About" }, { text: "Help" }];
  const generateButton = (paramObject) => {
    const { text } = paramObject;
    return <button className="rounded mx-4 text-md">{text}</button>;
  };
  const buttons = buttonsToGenerate.map((buttonParams) => generateButton(buttonParams));

  return (
    <div className="px-3 shadow-sm border-b border-gray-300">
      <img
        src={"https://eduadvisor.my/wp-content/uploads/2015/07/Logo-Monash-University-200.png"}
        alt="unavailable"
        width={80}
        height={80}
        className="inline-block mr-3"
      />
      {buttons}
    </div>
  );
};

export default Header;
